import type React from "react";
import { themeVar as colors } from "../design-tokens";

/* The `vb-btn*` classes in app.css carry only hover/press states; the look itself is inline, as on
   the other settings screens (ExtensionScreen). Without these a button renders as the browser's
   default gray box. */
export const primaryButton: React.CSSProperties = {
  padding: "9px 16px", borderRadius: 8, border: "none", background: colors.accent,
  color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
};
export const ghostButton: React.CSSProperties = {
  padding: "8px 14px", borderRadius: 8, border: `1px solid ${colors.border}`,
  background: colors.bgSurface, color: colors.textPrimary, fontSize: 13, cursor: "pointer",
};
export const fieldStyle: React.CSSProperties = {
  marginTop: 4, padding: "8px 10px", width: "100%", fontSize: 14, boxSizing: "border-box",
  border: `1px solid ${colors.border}`, borderRadius: 8, background: colors.bgSurface,
  color: colors.textPrimary,
};
export const whenDisabled = (disabled: boolean): React.CSSProperties =>
  disabled ? { opacity: 0.6, cursor: "not-allowed" } : {};
